/**
 * @file 数据请求公共方法
 */
import {
    stringify
} from 'qs';
import 'whatwg-fetch';
import fetchJsonp from 'fetch-jsonp';
import md5 from 'md5';

const AK = 'huibo_fe';
const SK = '123qaz_huibo_fe_321plm';

const sortQuery = (queryParams, timestamp = Date.now(), ak = AK) => {
    const queryString = queryParams ? queryParams + `&timestamp=${timestamp}&ak=${ak}` : `?timestamp=${timestamp}&ak=${ak}`;
    const params = new URLSearchParams(queryString);
    const sortedQueryString = new URLSearchParams([...params].filter(([key]) => !['sign'].includes(key)).sort()).toString();
    return sortedQueryString;
};

const appendQuery = (url, newParam) => {
    try {
        const baseUrl = window.location.origin;
        const urlObj = new URL(url, baseUrl);
        if (urlObj.search) {
            urlObj.search += `&${newParam}`;
        }
        else {
            urlObj.search = `?${newParam}`;
        }
        return urlObj.toString();
    }
    catch {
        return url;
    }

};
export default function request(url, options = {}, requestType = '') {
    const defaultOptions = {
        credentials: 'include'
    };

    const newOptions = {
        ...defaultOptions,
        ...options
    };
    if (newOptions.method === 'JSONP') {
        return fetchJsonp(url)
            .then(response => response.json())
            .catch(e => {
                console.error(e);
            });
    }
    if (newOptions.method === 'GETAUDIO') {
        newOptions.method = 'POST';
        newOptions.headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            ...newOptions.headers
        };
        newOptions.body = JSON.stringify(newOptions.body);

        return fetch(url, newOptions)
            .then(response => response.blob())
            .catch(e => {
                console.error(e);
            });
    }
    if (newOptions.method === 'POSTIMG') {
        newOptions.headers = {};
        const file = newOptions.body;
        const data = new FormData();
        data.append('file', newOptions.body.file);
        newOptions.body = data;
        newOptions.method = 'POST';
    }

    if (newOptions.method === 'POST') {
        if (!(newOptions.body instanceof FormData)) {
            newOptions.headers = {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                ...newOptions.headers
            };
            newOptions.body = stringify(newOptions.body);
        }
        else {
            // newOptions.body is FormData
            newOptions.headers = {
                Accept: 'application/json',
                ...newOptions.headers
            };
        }
    }
    else if (newOptions.method === 'POSTJSON') {
        newOptions.method = 'POST';
        newOptions.headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            ...newOptions.headers
        };
        newOptions.body = JSON.stringify(newOptions.body);

        const path = url.split('?')[0];
        const queryParams = url.split('?')[1];
        const timestamp = Math.floor(Date.now() / 1000);
        const sortedQueryString = sortQuery(queryParams, timestamp);
        const bodyStr = (newOptions.body ? newOptions.body : '');
        const md5Key = md5(`${AK}${SK}${timestamp}${path}${sortedQueryString}${bodyStr}`);
        const newQuery = `ak=${AK}&timestamp=${timestamp}&sign=${md5Key}`;
        url = appendQuery(url, newQuery);
    }
    return fetch(url, newOptions)
        .then(response => {
            if (requestType === 'download') {
                return response.blob();
            }
            return response.json();
        })
        .catch(e => {
            console.error(e);
        });
}

export const batchRequest = (reqArr, limit) => {
    const reqLen = reqArr.length;
    const resArr = new Array(reqLen);
    let i = 0;

    return new Promise((resolve, reject) => {
        const maxNum = reqLen >= limit ? limit : reqLen;

        const reqFn = async () => {
            if (i > reqLen - 1) {
                return;
            }
            const cur = i++;
            const fn = reqArr[cur];
            const data = await fn().catch(err => {
                return err;
            });

            resArr[cur] = data;

            // 不用length判断，因为resArr里面是empty，用Object.values
            if (i === Object.values(resArr).length) {
                resolve(resArr);
            }
            else {
                reqFn();
            }
        };

        while (i < maxNum) {
            reqFn();
        }
    });
};

// 封装Promise的xhr请求，仅用于给本地插件发请求，因为axios请求存在跨域问题
export const xhrRequest = (url, {method, body, timeout = 30000}) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        if (timeout) {
            xhr.timeout = timeout;
        }

        xhr.open(method, url, true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200 && JSON.parse(xhr.responseText)?.code === 0) {
                    resolve(xhr.responseText ? JSON.parse(xhr.responseText) : '');
                }
                else {
                    reject(xhr.responseText ? JSON.parse(xhr.responseText) : '');
                }
            }
        };

        xhr.onerror = () => {
            reject(new Error('Network error'));
        };

        xhr.send(JSON.stringify(body));
    });
};
